// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__bUAos","summary":"CartItem_summary__O+ZHU","price":"CartItem_price__GEUmB","amount":"CartItem_amount__7Ceiy","actions":"CartItem_actions__j9Brx"};